import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api/apiGet';
import {GET_FCM_DEVICES_ERROR, GET_FCM_DEVICES_START, GET_FCM_DEVICES_SUCCESS} from "../../types";

export function* create({payload}) {
  try {
    const url = '/devices/';
    const method = 'GET';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
    const results = yield call(apiCall, url, method, headers);
    /*
        let data = []
        results.data.map(e => {
          data.push(e.registration_id)
        })
    */
    yield put({type: GET_FCM_DEVICES_SUCCESS, results: results.data});
  } catch (error) {
    yield put({type: GET_FCM_DEVICES_ERROR, error});
  }
}

export default function* fcm_devices() {
  yield takeLatest(GET_FCM_DEVICES_START, create);
}
